<template>
  <SidePanel
    :isVisible="true"
    :rightCommand="true"
    @cancel="onCancel"
    @save="onSave"
    :header="header"
    :save="saveText"
    :cancel="cancelText"
  >
    <div class="sidepanel-body">
      <div class="panel-section-title text-weight-semi-bold">
        {{ $t('options.sectionChoices') }}
      </div>
      <p class="text-size-14">
        {{ $t('options.sectionChoicesDecription') }}
      </p>

      <div
        v-if="0"
        class="d-flex align-items-center text-weight-semi-bold mb-2"
      >
        <div class="col-1 text-left"></div>
        <div class="col-6 text-left ml-2">Filed</div>
        <div class="col-4 text-right">Required</div>
        <div class="col-1 text-left"></div>
        <div class="col-1"></div>
      </div>
      <div
        v-for="(attribute, index) in attributes"
        :key="attribute.id"
        class="participant-attribute d-flex mb-4 align-items-center"
      >
        <div class="col-1 h6 text-number mt-1">{{ index + 1 }}</div>
        <div class="col-7">
          <InputText label="Name des Feldes" v-model="attribute.label" />
        </div>
        <div class="col-3">
          <select-field
            :width="110"
            padding="0px"
            :options="options"
            v-model="attribute.mandatory"
          />
        </div>

        <div @click="removeAttribute(attribute.id)" class="col-1">
          <div class="">
            <font-awesome-icon :icon="['fal', 'trash-alt']" />
          </div>
        </div>
      </div>
      <div @click="addField" class="add-item text-primary m-3">
        <font-awesome-icon
          class="text-primary mt-1"
          :icon="['fal', 'plus-circle']"
        />
        Add aditional field
      </div>
      <div class="sidepanel-footer"></div>
    </div>
  </SidePanel>
</template>

<script>
import SidePanel from '@/components/Rendering/SidePanel.vue';
import InputText from '@/components/UI/InputText.vue';
import SelectField from '@/components/UI/SelectField';

import { mapState } from 'vuex';

export default {
  name: 'EditParticipantAttributes',

  //  props: ['options'],

  components: {
    SidePanel,
    InputText,
    SelectField,
  },

  data() {
    return {
      newUser: null,
      currentUser: null,
      fake: 'just to show something',
      locale: { code: 'de', label: this.$t('profileDropDown.deLanguageText') },
      ownerSelection: { code: 'all', label: this.$t('polls.lblAllPolls') },
      attributes: null,
      lastId: -1,
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.Login.user,
      poll: (state) => state.poll.poll,
    }),

    options() {
      let options = [
        { code: true, label: 'Mandatory' },
        { code: false, label: 'Optional' },
      ];
      return options;
    },

    optionsLanguages() {
      let options = [
        { code: 'de', label: this.$t('profileDropDown.deLanguageText') },
        { code: 'en', label: this.$t('profileDropDown.enLanguageText') },
      ];
      return options;
    },

    isAnonymousUser() {
      if (this.poll.user.email == 'dummy@kulibri.com') {
        return true;
      }
      return false;
    },

    header() {
      return 'Particpant Attribute';
    },

    saveText() {
      return this.$t('profile.dlgSave');
    },

    cancelText() {
      return this.$t('profile.dlgCancel');
    },
  },

  methods: {
    addField() {
      const attribute = {
        id: this.lastId,
        label: '',
        placeholder: '',
        mandatory: {
          code: 1,
          label: 'Mandatory',
        },
      };
      this.attributes.push(attribute);
      this.lastId--;
    },

    removeAttribute(id) {
      console.log('Remove attribute:', id);

      this.attributes = this.attributes.filter((obj) => obj.id !== id);
    },
    onLocaleSelected(selected) {
      console.log('onSelectedLocate:', selected);
      this.$i18n.locale = this.locale.code;
    },
    onCancel() {
      console.log('Eedit profile cancel');
      this.$i18n.locale = this.currentUser.locale;
      this.$emit('close', null);
    },
    onSave() {
      for (const attribute of this.attributes) {
        attribute.mandatory = attribute.mandatory.code;
      }
    this.$store.dispatch('updateParticipantAttributes', this.attributes);
      this.$emit('close');
    },
    onChangePassword() {
      this.$emit('close', 'edit-password');
    },

    boolean2dropdown(value) {
      console.log('boolean2dropdown:', value);
      const label = value ? 'Mandatory' : 'Optional';
      const code = value;
      return { code, label };
    },
  },

  created() {
    this.newUser = { ...this.user };
    this.currentUser = this.user;
  },

  mounted() {
    let locale = this.optionsLanguages.find(
      (locale) => locale.code === this.user.locale
    );
    this.locale = locale;
    this.attributes = JSON.parse(
      JSON.stringify(this.poll.participant_attributes)
    );
    for (const attribute of this.attributes) {
      attribute.mandatory = this.boolean2dropdown(attribute.mandatory);
    }
    console.log(
      'attributes:',
      this.attributes,
      this.poll.participant_attributes
    );
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.text-number {
  color: $date-color;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
